<div nz-row class="rnd-intro-image"></div>
<div class="rnd-message" style="height: 380px;">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px;">
      연구전담부서 소개<br />
    </div>
    <div style="font-weight: normal; font-size: 18px;">
      <p>
        당 연구전담부서는 엘리베이터에 전자기술을 접합한 Mobile Call, Elevator<br />
        환경실험 관련 Inhalation Chamber 등을 개발 완료하여 국내 시장에 판매 중입니다.<br />
        또한, 최근 정보 인식 기술의 핵심으로 자리 잡은 RFID TAG 개발 및 양산 중에 있으며 점차 확장되고 있는<br />
        RFID 시장에 성공적으로 진입하기 위하여 고 부가가치 특수 TAG 등 신제품 개발에도 부단한 노력을 하고 있습니다.<br />
      </p>
    </div>
  </div>
</div>
<div class="rnd-item-intro">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 38px; font-family: Roboto,sans-serif; padding-top: 100px;">
      RFID Tag<br />
    </div>
    <div style="font-weight: normal; font-size: 18px;">
      <p>
        무선인식 기술을 활용하여 각종 데이터를 주고 받을 수 있는 시스템을 말하며 자동화 산업, 물류 관리<br />
        유통 공급 망 관리 등에 적용되며 최근에는 각종 시장 품목의 진품 관리 등에도 다양하게 적용되고 있다.<br />
      </p>
    </div>
  </div>
  <div style="padding-left: 200px; padding-right: 200px; padding-top: 50px;">
    <table style="width: 100%;">
      <tr style="border-top-style: solid; border-top-color: #585858; border-top-width: 2px;
          border-bottom-style: solid; border-bottom-color: #585858; border-bottom-width: 1px;
          font-family: 'Noto Sans',sans-serif; font-size: 16px;">
        <td style="width: 200px;">용도</td>
        <td style="width: 250px;">제품 외장</td>
        <td style="width: 250px;">제품 구성</td>
        <td style="width: 200px;">SPEC</td>
      </tr>
      <tr class="product-container"
        *ngFor="let product of Products">
        <td style="font-family: Roboto,sans-serif; font-size: 18px; font-weight: bold;">{{product.type}}</td>
        <td style="align-content: center"><img src="{{product.imgUrl1}}" /></td>
        <td style="align-content: center"><img src="{{product.imgUrl2}}" /></td>
        <td>
          <table style="width: 100%">
            <tr class="spec-tr">
              <td class="spec-name">Antenna Type</td>
              <td class="spec-value">{{product.antennaType}}</td>
            </tr>
            <tr class="spec-tr">
              <td class="spec-name">Protocol</td>
              <td class="spec-value">{{product.protocol}}</td></tr>
            <tr class="spec-tr">
              <td class="spec-name">Chip</td>
              <td class="spec-value">{{product.chip}}</td>
            </tr>
            <tr class="spec-tr">
              <td class="spec-name">Center Frequency</td>
              <td class="spec-value">{{product.centerFrequency}}</td>
            </tr>
            <tr class="spec-tr">
              <td class="spec-name">Read Range</td>
              <td class="spec-value">{{product.readRange}}</td>
            </tr>
            <tr class="spec-tr" [ngStyle]="{'border-bottom' : product.index === 2 ? 'none' : ''}" [attr.aria-rowspan]="product.index === 2 ? 2 : 1">
              <td class="spec-name">Size</td>
              <td class="spec-value">{{product.size}}</td>
            </tr>
            <tr class="spec-tr" style="border-bottom: none;" *ngIf="product.index !== 2">
              <td class="spec-name">Conjugate / Matching</td>
              <td class="spec-value">{{product.conjugate}}</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>

  <div class="rnd-message">
    <div class="content" style="height: 300px;">
      <div style="font-weight: bold; padding-bottom: 5px; font-size: 38px; font-family: Roboto,sans-serif">
        Inhalation Chamber<br />
      </div>
      <div style="font-weight: bold; padding-bottom: 5px; font-size: 18px; font-family: 'Noto Sans',sans-serif">
        Whole Body Exposure Chamber<br />
      </div>
      <div style="font-weight: normal; font-size: 18px; font-family: 'Noto Sans',sans-serif">
        <p>
          -챔버 상단에 FFU(Fan Filter Unit)를 설치하여 챔버 내 균일한 기류와 입자 분포가 가능.<br />
          - ISO 14644-3에 근거한 챔버 내 입자 분포 측정 테스트 결과 제출.<br />
          - 챔버 누수 리포트 제출.<br />
        </p>
      </div>
    </div>
  </div>
  <div class="rnd-chamber-image"></div>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
